/**
 * Curated icon list for the card layout picker.
 * Using named imports (tree-shakeable) instead of `import * as LucideIconSet`
 * which would bundle all ~900 icons.
 */
import {
  // People & Organizations
  Building2, Building, Store, Factory, Hospital, Landmark, Briefcase, Crown, Warehouse, Handshake, GraduationCap,
  User, Users, UserCheck, UserX, UserPlus, UserCog, Contact, Baby,
  // Finance
  DollarSign, Euro, Bitcoin, CreditCard, Wallet, Banknote, PiggyBank, Receipt, Coins, HandCoins,
  CircleDollarSign, BadgeDollarSign, BadgePercent, Scale, Gem, Diamond, Percent, Hash,
  // Communication
  Mail, MailOpen, Phone, PhoneCall, PhoneIncoming, PhoneOutgoing,
  MessageSquare, MessageCircle, Send, Bell, BellRing, Video, Mic, Headphones,
  // Location
  Globe, Globe2, Map, MapPin, Navigation, Navigation2, Compass, Home,
  // Time
  Calendar, CalendarCheck, CalendarClock, CalendarDays, Clock, Timer, AlarmClock, Hourglass, Watch,
  // Products & Shopping
  Package, PackageOpen, ShoppingCart, ShoppingBag, Truck, Box, Boxes, Archive, Gift, Container,
  // Documents
  FileText, File, FileCheck, FilePlus, FileX, Folder, FolderOpen, FolderPlus,
  Clipboard, ClipboardCheck, Book, BookOpen, Bookmark, Link, Link2, Paperclip, Printer, Database, Server,
  // Analytics & Charts
  BarChart, BarChart2, BarChart3, BarChart4,
  PieChart, LineChart, Activity, Gauge, Target, TrendingUp, TrendingDown, Presentation, Workflow,
  // Business
  Trophy, Award, Medal, Star, Flag, Milestone, Rocket, Zap, Flame, Lightbulb, Brain, Coffee, Puzzle,
  // Security
  Shield, ShieldCheck, Lock, Unlock, Key, Fingerprint, Eye, EyeOff, Power,
  // Health & Status
  Stethoscope, Heart, Smile, ThumbsUp, ThumbsDown, Leaf, Camera, Film, AlertCircle,
  // Actions
  CheckCircle, XCircle, AlertTriangle, Info, HelpCircle, Filter, Sliders,
  Layers, Settings, Wrench, Tag, Search, RefreshCw, Download, Upload, Share2,
  // Misc
  Laptop, Monitor, Smartphone, Tablet, Wifi, Bluetooth, Cloud, CloudUpload, CloudDownload,
  // Navigation
  ChevronRight, ChevronLeft, ChevronUp, ChevronDown, ArrowRight, ArrowLeft,
} from "lucide-react";

export const ICON_OPTIONS = [
  { name: "none", Icon: null, label: "Nenhum" },
  // Pessoas & Organizações
  { name: "Building2", Icon: Building2, label: "Empresa" }, { name: "Building", Icon: Building, label: "Prédio" },
  { name: "Store", Icon: Store, label: "Loja" }, { name: "Factory", Icon: Factory, label: "Fábrica" },
  { name: "Hospital", Icon: Hospital, label: "Hospital" }, { name: "Landmark", Icon: Landmark, label: "Marco" },
  { name: "Briefcase", Icon: Briefcase, label: "Negócio" }, { name: "Crown", Icon: Crown, label: "VIP" },
  { name: "Warehouse", Icon: Warehouse, label: "Depósito" }, { name: "Handshake", Icon: Handshake, label: "Parceria" },
  { name: "GraduationCap", Icon: GraduationCap, label: "Formação" },
  { name: "User", Icon: User, label: "Pessoa" }, { name: "Users", Icon: Users, label: "Equipe" },
  { name: "UserCheck", Icon: UserCheck, label: "Cliente" }, { name: "UserX", Icon: UserX, label: "Inativo" },
  { name: "UserPlus", Icon: UserPlus, label: "Novo" }, { name: "UserCog", Icon: UserCog, label: "Admin" },
  { name: "Contact", Icon: Contact, label: "Contato" }, { name: "Baby", Icon: Baby, label: "Bebê" },
  // Finanças
  { name: "DollarSign", Icon: DollarSign, label: "Dólar" }, { name: "Euro", Icon: Euro, label: "Euro" },
  { name: "Bitcoin", Icon: Bitcoin, label: "Bitcoin" }, { name: "CreditCard", Icon: CreditCard, label: "Cartão" },
  { name: "Wallet", Icon: Wallet, label: "Carteira" }, { name: "Banknote", Icon: Banknote, label: "Nota" },
  { name: "PiggyBank", Icon: PiggyBank, label: "Poupança" }, { name: "Receipt", Icon: Receipt, label: "Recibo" },
  { name: "Coins", Icon: Coins, label: "Moedas" }, { name: "HandCoins", Icon: HandCoins, label: "Pagamento" },
  { name: "CircleDollarSign", Icon: CircleDollarSign, label: "Valor" }, { name: "BadgeDollarSign", Icon: BadgeDollarSign, label: "Preço" },
  { name: "BadgePercent", Icon: BadgePercent, label: "Desconto" }, { name: "Scale", Icon: Scale, label: "Balança" },
  { name: "Gem", Icon: Gem, label: "Precioso" }, { name: "Diamond", Icon: Diamond, label: "Diamante" },
  { name: "Percent", Icon: Percent, label: "Porcentagem" }, { name: "Hash", Icon: Hash, label: "Número" },
  // Comunicação
  { name: "Mail", Icon: Mail, label: "Email" }, { name: "MailOpen", Icon: MailOpen, label: "Email aberto" },
  { name: "Phone", Icon: Phone, label: "Telefone" }, { name: "PhoneCall", Icon: PhoneCall, label: "Ligação" },
  { name: "PhoneIncoming", Icon: PhoneIncoming, label: "Entrada" }, { name: "PhoneOutgoing", Icon: PhoneOutgoing, label: "Saída" },
  { name: "MessageSquare", Icon: MessageSquare, label: "Mensagem" }, { name: "MessageCircle", Icon: MessageCircle, label: "Chat" },
  { name: "Send", Icon: Send, label: "Enviar" }, { name: "Bell", Icon: Bell, label: "Alerta" },
  { name: "BellRing", Icon: BellRing, label: "Notificação" }, { name: "Video", Icon: Video, label: "Vídeo" },
  { name: "Mic", Icon: Mic, label: "Microfone" }, { name: "Headphones", Icon: Headphones, label: "Fone" },
  // Localização
  { name: "Globe", Icon: Globe, label: "Site" }, { name: "Globe2", Icon: Globe2, label: "Mundo" },
  { name: "Map", Icon: Map, label: "Mapa" }, { name: "MapPin", Icon: MapPin, label: "Local" },
  { name: "Navigation", Icon: Navigation, label: "Navegar" }, { name: "Navigation2", Icon: Navigation2, label: "Direção" },
  { name: "Compass", Icon: Compass, label: "Bússola" }, { name: "Home", Icon: Home, label: "Casa" },
  // Tempo
  { name: "Calendar", Icon: Calendar, label: "Data" }, { name: "CalendarCheck", Icon: CalendarCheck, label: "Agenda" },
  { name: "CalendarClock", Icon: CalendarClock, label: "Prazo" }, { name: "CalendarDays", Icon: CalendarDays, label: "Calendário" },
  { name: "Clock", Icon: Clock, label: "Hora" }, { name: "Timer", Icon: Timer, label: "Timer" },
  { name: "AlarmClock", Icon: AlarmClock, label: "Alarme" }, { name: "Hourglass", Icon: Hourglass, label: "Tempo" },
  { name: "Watch", Icon: Watch, label: "Relógio" },
  // Produtos & Estoque
  { name: "Package", Icon: Package, label: "Produto" }, { name: "PackageOpen", Icon: PackageOpen, label: "Entregue" },
  { name: "ShoppingCart", Icon: ShoppingCart, label: "Compra" }, { name: "ShoppingBag", Icon: ShoppingBag, label: "Sacola" },
  { name: "Truck", Icon: Truck, label: "Entrega" }, { name: "Box", Icon: Box, label: "Caixa" },
  { name: "Boxes", Icon: Boxes, label: "Estoque" }, { name: "Archive", Icon: Archive, label: "Arquivo" },
  { name: "Gift", Icon: Gift, label: "Presente" },
  // Documentos
  { name: "FileText", Icon: FileText, label: "Documento" }, { name: "File", Icon: File, label: "Arquivo" },
  { name: "FileCheck", Icon: FileCheck, label: "Aprovado" }, { name: "FilePlus", Icon: FilePlus, label: "Novo arquivo" },
  { name: "Folder", Icon: Folder, label: "Pasta" }, { name: "FolderOpen", Icon: FolderOpen, label: "Pasta aberta" },
  { name: "FolderPlus", Icon: FolderPlus, label: "Nova pasta" }, { name: "Clipboard", Icon: Clipboard, label: "Lista" },
  { name: "ClipboardCheck", Icon: ClipboardCheck, label: "Checklist" }, { name: "Book", Icon: Book, label: "Livro" },
  { name: "BookOpen", Icon: BookOpen, label: "Manual" }, { name: "Bookmark", Icon: Bookmark, label: "Marcador" },
  { name: "Link", Icon: Link, label: "Link" }, { name: "Link2", Icon: Link2, label: "Conexão" },
  { name: "Paperclip", Icon: Paperclip, label: "Anexo" }, { name: "Printer", Icon: Printer, label: "Impressora" },
  { name: "Database", Icon: Database, label: "Banco de dados" }, { name: "Server", Icon: Server, label: "Servidor" },
  // Analytics
  { name: "BarChart", Icon: BarChart, label: "Barras" }, { name: "BarChart2", Icon: BarChart2, label: "Barras 2" },
  { name: "BarChart3", Icon: BarChart3, label: "Barras 3" }, { name: "BarChart4", Icon: BarChart4, label: "Barras 4" },
  { name: "PieChart", Icon: PieChart, label: "Pizza" }, { name: "LineChart", Icon: LineChart, label: "Linha" },
  { name: "Activity", Icon: Activity, label: "Atividade" }, { name: "Gauge", Icon: Gauge, label: "Medidor" },
  { name: "Target", Icon: Target, label: "Meta" }, { name: "TrendingUp", Icon: TrendingUp, label: "Crescimento" },
  { name: "TrendingDown", Icon: TrendingDown, label: "Queda" }, { name: "Presentation", Icon: Presentation, label: "Apresentação" },
  { name: "Workflow", Icon: Workflow, label: "Fluxo" },
  // Conquistas
  { name: "Trophy", Icon: Trophy, label: "Troféu" }, { name: "Award", Icon: Award, label: "Prêmio" },
  { name: "Medal", Icon: Medal, label: "Medalha" }, { name: "Star", Icon: Star, label: "Estrela" },
  { name: "Flag", Icon: Flag, label: "Bandeira" }, { name: "Milestone", Icon: Milestone, label: "Marco" },
  { name: "Rocket", Icon: Rocket, label: "Lançamento" }, { name: "Zap", Icon: Zap, label: "Velocidade" },
  { name: "Flame", Icon: Flame, label: "Quente" }, { name: "Lightbulb", Icon: Lightbulb, label: "Ideia" },
  { name: "Brain", Icon: Brain, label: "Inteligência" }, { name: "Coffee", Icon: Coffee, label: "Reunião" },
  { name: "Puzzle", Icon: Puzzle, label: "Solução" },
  // Segurança
  { name: "Shield", Icon: Shield, label: "Segurança" }, { name: "ShieldCheck", Icon: ShieldCheck, label: "Verificado" },
  { name: "Lock", Icon: Lock, label: "Bloqueado" }, { name: "Unlock", Icon: Unlock, label: "Desbloqueado" },
  { name: "Key", Icon: Key, label: "Chave" }, { name: "Fingerprint", Icon: Fingerprint, label: "Biometria" },
  { name: "Eye", Icon: Eye, label: "Visível" }, { name: "EyeOff", Icon: EyeOff, label: "Oculto" },
  { name: "Power", Icon: Power, label: "Ativo" },
  // Status & Ações
  { name: "CheckCircle", Icon: CheckCircle, label: "Concluído" }, { name: "XCircle", Icon: XCircle, label: "Cancelado" },
  { name: "AlertCircle", Icon: AlertCircle, label: "Aviso" }, { name: "AlertTriangle", Icon: AlertTriangle, label: "Atenção" },
  { name: "Info", Icon: Info, label: "Info" }, { name: "HelpCircle", Icon: HelpCircle, label: "Ajuda" },
  { name: "Filter", Icon: Filter, label: "Filtro" }, { name: "Sliders", Icon: Sliders, label: "Configurar" },
  { name: "Layers", Icon: Layers, label: "Camadas" }, { name: "Settings", Icon: Settings, label: "Config." },
  { name: "Wrench", Icon: Wrench, label: "Ferramenta" }, { name: "Tag", Icon: Tag, label: "Etiqueta" },
  { name: "Search", Icon: Search, label: "Busca" }, { name: "RefreshCw", Icon: RefreshCw, label: "Atualizar" },
  { name: "Download", Icon: Download, label: "Download" }, { name: "Upload", Icon: Upload, label: "Upload" },
  { name: "Share2", Icon: Share2, label: "Compartilhar" },
  // Bem-estar & Misc
  { name: "Stethoscope", Icon: Stethoscope, label: "Saúde" }, { name: "Heart", Icon: Heart, label: "Favorito" },
  { name: "Smile", Icon: Smile, label: "Satisfação" }, { name: "ThumbsUp", Icon: ThumbsUp, label: "Positivo" },
  { name: "ThumbsDown", Icon: ThumbsDown, label: "Negativo" }, { name: "Leaf", Icon: Leaf, label: "Sustentável" },
  { name: "Camera", Icon: Camera, label: "Foto" }, { name: "Film", Icon: Film, label: "Vídeo" },
  { name: "Laptop", Icon: Laptop, label: "Laptop" }, { name: "Monitor", Icon: Monitor, label: "Monitor" },
  { name: "Smartphone", Icon: Smartphone, label: "Celular" }, { name: "Wifi", Icon: Wifi, label: "Wi-Fi" },
  { name: "Cloud", Icon: Cloud, label: "Nuvem" }, { name: "CloudUpload", Icon: CloudUpload, label: "Upload nuvem" },
  { name: "CloudDownload", Icon: CloudDownload, label: "Download nuvem" },
];

// Fast lookup map by name for rendering
export const ICON_MAP = Object.fromEntries(
  ICON_OPTIONS.filter(o => o.Icon).map(o => [o.name, o.Icon])
);
